@if (contentlet$ | async; as contentlet) {
<custom-dot-cms-edit-contentlet-wrapper [contentlet]="contentlet" class="d-block">
  <custom-dot-cms-web-page-content [identifier]="contentlet?.identifier" [setAttribute]="false" />
</custom-dot-cms-edit-contentlet-wrapper>
}
<ish-modal-dialog
  #conformDialog
  [options]="{
    confirmText: 'confirm',
    rejectText: 'cancel',
    titleText: 'Confirm Newsletter Subscription'
  }"
  (confirmed)="confirmMail()"
>
  Do you want enable Newsletter Subscription?
</ish-modal-dialog>
